import { ActivatedRouteSnapshot, RouterStateSnapshot, Routes } from "@angular/router";
import { TRANSPORT_MANAGEMENT_ROUTES } from "../features/transport-management/constants/routes.constant";
import { AREA_MANAGEMENT_ROUTES } from "../features/area-management/constants/routes.constant";
import { ACCESS_CONTROL_ROUTES } from "../features/access-control/constants/routes.constant";
import { AccessControlModule } from "../features/access-control/access-control.module";
import { TransportManagementModule } from "../features/transport-management/transport-management.module";
import { AreaManagementModule } from "../features/area-management/area-management.module";
import { deactivate, hasPathInSegment } from "@core/constants/routes.constant";
import { RoutePlaceholderComponent } from "@core/components/route-placeholder.component";
import { canActivateProjectOverview } from "../components/pages/project-overview/guards/project-overview.guard";
import { WILDCARD_ROUTE } from "@shared/common/routes.common";
import { ExtjsWildcardRouteComponent } from "@core/components/pages/extjs/extjs-wildcard-route.component";
import { InjectionToken } from "@angular/core";


export const PROJECT_NUMBER: InjectionToken<string> = new InjectionToken<string>("PROJECT_NUMBER");

/* eslint-disable-next-line @tseslint/typedef */
const MODULE_IMPORTS = {
  // eslint-disable-next-line @tseslint/typedef
  accessControl: async (): Promise<typeof AccessControlModule> => await import("../features/access-control/access-control.module").then((m) => m.AccessControlModule),
  // eslint-disable-next-line @tseslint/typedef
  transportManagement: async (): Promise<typeof TransportManagementModule> => await import("../features/transport-management/transport-management.module").then((m) => m.TransportManagementModule),
  // eslint-disable-next-line @tseslint/typedef
  areaManagement: async (): Promise<typeof AreaManagementModule> => await import("../features/area-management/area-management.module").then((m) => m.AreaManagementModule)
};
const TRANSLATION_SCOPE: string = "feature/project-routes";

/* eslint-disable-next-line @tseslint/typedef */
export const PROJECT_ROUTE_NAMES = {
  details: "details",
  specifications: "specifications",
  openingTimes: "opening-times",
  specialTimes: "special-times",
  documents: "documents",
  staffData: "staff-data"
} as const;
export const PROJECT_ROUTES: Routes = [
  {
    path: "",
    canActivate: [ canActivateProjectOverview ],
    // eslint-disable-next-line @tseslint/typedef
    loadComponent: async () => await import("@features/project/components/pages/project-overview/project-overview.component").then((m) => m.ProjectOverviewComponent)
  },
  deactivate({
    path: "new",
    component: RoutePlaceholderComponent,
    data: {
      leaf: true,
      context: {
        breadcrumb: {
          "static": { translationInfo: {
            defaultText: "Neues Projekt",
            scope: TRANSLATION_SCOPE,
            token: "breadcrumb-label-new-project"
          } }
        }
      }
    }
  }),
  {
    path: ":projectNumber",
    data: {
      context: {
        breadcrumb: {
          apiPath: "api/projects/{projectNumber}"
        },
        sidebar: {
          apiPath: "api/menu/projects/{projectNumber}"
        }
      }
    },
    children: [
      /*
       * {
       *   path: "test",
       *   // eslint-disable-next-line @tseslint/typedef
       *   loadComponent: async () => await import("@features/project/components/tabs/project-tabs/project-tabs.component").then((m) => m.ProjectTabsComponents),
       */

      /*
       *   Providers: [
       *     DirtyStateService
       *   ],
       *   children: [
       *     {
       *       path: "",
       *       pathMatch: "full",
       *       redirectTo: PROJECT_ROUTE_NAMES.details
       *     },
       *     {
       *       path: PROJECT_ROUTE_NAMES.details,
       *       component: ProjectDetailsComponent,
       *       canDeactivate: [ pendingChangedGuard ],
       *       data: {
       *         context: {
       *           breadcrumb: {
       *             "static": { translationInfo: {
       *               defaultText: "Details",
       *               scope: TRANSLATION_SCOPE,
       *               token: "breadcrumb-label-details"
       *             } }
       *           }
       *         }
       *       }
       *     },
       *     {
       *       path: PROJECT_ROUTE_NAMES.openingTimes,
       *       component: ProjectOpeningTimesComponent,
       *       canDeactivate: [ pendingChangedGuard ]
       *     },
       *     {
       *       path: PROJECT_ROUTE_NAMES.specifications,
       *       component: ProjectSpecificationsComponent,
       *       canDeactivate: [ pendingChangedGuard ]
       *     },
       *     {
       *       path: PROJECT_ROUTE_NAMES.specialTimes,
       *       component: ProjectSpecialTimesComponent
       *     },
       *     {
       *       path: PROJECT_ROUTE_NAMES.documents,
       *       component: ProjectDocumentsComponent
       *     },
       *     {
       *       path: PROJECT_ROUTE_NAMES.staffData,
       *       component: ProjectStaffDataOverviewComponent,
       *       canDeactivate: [ pendingChangedGuard ]
       *     }
       *   ]
       * },
       */
      deactivate({
        path: "",
        component: RoutePlaceholderComponent
      }),
      deactivate({
        path: "settings",
        component: RoutePlaceholderComponent,
        children: [
          {
            path: "details",
            component: RoutePlaceholderComponent,
            data: {
              context: {
                breadcrumb: {
                  "static": { translationInfo: {
                    defaultText: "Details",
                    scope: TRANSLATION_SCOPE,
                    token: "breadcrumb-label-details"
                  } }
                }
              }
            }
          },
          {
            path: "module-settings",
            component: RoutePlaceholderComponent,
            data: {
              context: {
                breadcrumb: {
                  "static": { translationInfo: {
                    defaultText: "Modul-Einstellungen",
                    scope: TRANSLATION_SCOPE,
                    token: "breadcrumb-label-module-settings"
                  } }
                }
              }
            }
          },
          {
            path: "reports-settings",
            component: RoutePlaceholderComponent,
            data: {
              context: {
                breadcrumb: {
                  "static": { translationInfo: {
                    defaultText: "Auswertungen und Listen",
                    scope: TRANSLATION_SCOPE,
                    token: "breadcrumb-label-reports-and-lists"
                  } }
                }
              }
            }
          },
          {
            path: "opening",
            component: RoutePlaceholderComponent,
            data: {
              context: {
                breadcrumb: {
                  "static": { translationInfo: {
                    defaultText: "Projektzeiten",
                    scope: TRANSLATION_SCOPE,
                    token: "breadcrumb-label-project-times"
                  } }
                }
              }
            }
          },
          {
            path: "customer-documents",
            component: RoutePlaceholderComponent,
            data: {
              context: {
                breadcrumb: {
                  "static": { translationInfo: {
                    defaultText: "Unternehmensdokumente",
                    scope: TRANSLATION_SCOPE,
                    token: "breadcrumb-label-customer-documents"
                  } }
                }
              }
            }
          },
          {
            path: "employee-field-settings",
            component: RoutePlaceholderComponent,
            data: {
              context: {
                breadcrumb: {
                  "static": { translationInfo: {
                    defaultText: "Feldanpassungen Mitarbeiterdaten",
                    scope: TRANSLATION_SCOPE,
                    token: "breadcrumb-label-employee-field-settings"
                  } }
                }
              }
            }
          },
          {
            path: "work-control",
            component: RoutePlaceholderComponent,
            data: {
              context: {
                breadcrumb: {
                  "static": { translationInfo: {
                    defaultText: "Work-Control",
                    scope: TRANSLATION_SCOPE,
                    token: "breadcrumb-label-work-control"
                  } }
                }
              }
            }
          }
        ]
      }),
      deactivate({
        path: "assign-building-owner",
        component: RoutePlaceholderComponent,
        data: {
          leaf: true,
          context: {
            breadcrumb: {
              "static": { translationInfo: {
                defaultText: "Bauherr/in",
                scope: TRANSLATION_SCOPE,
                token: "breadcrumb-label-assign-building-owner"
              } }
            }
          }
        }
      }),
      deactivate({
        path: "access-control",
        component: RoutePlaceholderComponent,
        loadChildren: MODULE_IMPORTS.accessControl,
        data: {
          routes: () => ACCESS_CONTROL_ROUTES,
          context: {
            breadcrumb: {
              "static": { translationInfo: {
                defaultText: "Zutrittskontrolle",
                scope: TRANSLATION_SCOPE,
                token: "breadcrumb-label-access-control"
              } }
            }
          }
        }
      }),
      deactivate({
        path: "area-management",
        component: RoutePlaceholderComponent,
        loadChildren: MODULE_IMPORTS.areaManagement,
        data: {
          routes: () => AREA_MANAGEMENT_ROUTES,
          context: {
            breadcrumb: {
              "static": { translationInfo: {
                defaultText: "Flächenmanagement",
                scope: TRANSLATION_SCOPE,
                token: "breadcrumb-label-area-management"
              } }
            }
          }
        }
      }),
      deactivate({
        path: "transport-management",
        component: RoutePlaceholderComponent,
        loadChildren: MODULE_IMPORTS.transportManagement,
        data: {
          routes: () => TRANSPORT_MANAGEMENT_ROUTES,
          context: {
            breadcrumb: {
              "static": { translationInfo: {
                defaultText: "Transport Management",
                scope: TRANSLATION_SCOPE,
                token: "breadcrumb-label-transport-management"
              } }
            }
          }
        }
      }),
      deactivate({
        path: "hire-customer",
        component: RoutePlaceholderComponent,
        data: {
          leaf: true,
          context: {
            breadcrumb: {
              "static": { translationInfo: {
                defaultText: "Unternehmen beauftragen",
                scope: TRANSLATION_SCOPE,
                token: "breadcrumb-label-hire-customer"
              } }
            }
          }
        }
      }),
      deactivate({
        path: "structure",
        component: RoutePlaceholderComponent,
        data: {
          context: {
            breadcrumb: { "static": { translationInfo: {
              defaultText: "Projektstruktur",
              scope: TRANSLATION_SCOPE,
              token: "breadcrumb-label-project-structure"
            } } }
          }
        }
      }),
      deactivate({
        path: "plans",
        component: RoutePlaceholderComponent,
        data: {
          context: {
            breadcrumb: { "static": { translationInfo: {
              defaultText: "Projektpläne",
              scope: TRANSLATION_SCOPE,
              token: "breadcrumb-label-project-plans"
            } } }
          }
        },
        children: [
          {
            path: "define-object",
            component: RoutePlaceholderComponent,
            data: {
              context: {
                breadcrumb: { "static": { translationInfo: {
                  defaultText: "Bauteile/Objekte definieren",
                  scope: TRANSLATION_SCOPE,
                  token: "breadcrumb-label-define-object"
                } } }
              }
            }
          }
        ]
      }),
      deactivate({
        path: "construction-notifications",
        component: RoutePlaceholderComponent,
        data: {
          context: {
            breadcrumb: { "static": { translationInfo: {
              defaultText: "Alle Benachrichtigungen",
              scope: TRANSLATION_SCOPE,
              token: "breadcrumb-label-all-notifications"
            } } }
          }
        },
        children: [
          {
            path: "new",
            component: RoutePlaceholderComponent,
            data: {
              context: {
                breadcrumb: { "static": { translationInfo: {
                  defaultText: "Neue Baustellenmeldung",
                  scope: TRANSLATION_SCOPE,
                  token: "breadcrumb-label-new-construction-notification"
                } } }
              }
            }
          },
          {
            path: "fromTemplate",
            component: RoutePlaceholderComponent,
            data: {
              leaf: true,
              context: {
                breadcrumb: { "static": { translationInfo: {
                  defaultText: "Neue Baustellenmeldung",
                  scope: TRANSLATION_SCOPE,
                  token: "breadcrumb-label-new-construction-notification"
                } } }
              }
            }
          },
          {
            path: ":notificationNumber",
            component: RoutePlaceholderComponent,
            data: {
              context: {
                breadcrumb: {
                  "static": { translationInfo: {
                    defaultText: "Nachricht {notificationNumber}",
                    scope: TRANSLATION_SCOPE,
                    token: "breadcrumb-label-notification-number"
                  } }
                }
              }
            }
          }
        ]
      }),
      deactivate({
        path: "administration",
        component: RoutePlaceholderComponent,
        children: [
          {
            path: "terminals",
            component: RoutePlaceholderComponent,
            data: {
              context: {
                breadcrumb: {
                  "static": { translationInfo: {
                    defaultText: "ZUKO Terminals",
                    scope: TRANSLATION_SCOPE,
                    token: "breadcrumb-label-zuko-terminals"
                  } }
                }
              }
            }
          }
        ]
      }),
      {
        path: WILDCARD_ROUTE,
        component: ExtjsWildcardRouteComponent,
        canActivate: [
          (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => !hasPathInSegment("extjs")(route, state)
        ]
      }
    ]
  }
];
